import { numberFormatter } from 'helpers'
import { PaymentSummaryType } from '../types'

type ClientTransactionDataType = {
    allEnrollment: number
    balance: number
    last_voucher_date?: string
}

export const buildPaymentSummaryProps = (
    { allEnrollment, balance }: ClientTransactionDataType,
    lastVoucherDate: string
): PaymentSummaryType => ({
    allEnrollment,
    formattedAllEnrollment: numberFormatter(allEnrollment),
    balance,
    formattedBalance: numberFormatter(balance),
    paymentLeft: allEnrollment - balance,
    formattedPaymentLeft: numberFormatter(allEnrollment - balance),
    percentage:
        allEnrollment === 0
            ? 0
            : parseFloat(((balance / allEnrollment) * 100).toString()),
    lastVoucherDate
})
